import { LOAD_BUSINESS_ACTIVITIES } from "../action";
import { businessActivities } from "./initial-store";

const initialState = businessActivities;

function businessActivitiesReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_BUSINESS_ACTIVITIES:
      return action.payload;
    default:
      return state;
  }
}

export default businessActivitiesReducer;
